import franchiseTerritoryData from "../data/franchise-territory-cities.json";

export interface TerritoryCity {
  name: string;
  state?: string;
  href?: string;
}

export const isPrimaryFranchise = (
  parentId?: number | string | null,
): boolean => parentId === 0 || parentId === "0";

interface FranchiseTerritoryData {
  branches?: Record<string, { cities?: TerritoryCity[] }>;
}

export const getTerritoryCities = (branchCode?: string): TerritoryCity[] => {
  if (!branchCode) return [];

  const branch = (franchiseTerritoryData as FranchiseTerritoryData).branches?.[
    branchCode
  ];
  return Array.isArray(branch?.cities) ? branch.cities : [];
};